import React from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import PinClipart1 from "../assets/img/custom/PinClipart1.png";

import routes from "routes.js";

const Auth = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.body.classList.add("bg-default");
    return () => {
      document.body.classList.remove("bg-default");
    };
  }, []);
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <div ref={mainContent}>
        <Container fluid>
          <Row className="auth-right">
            <Col lg={5} className="bg-white-1 pb-4 pb-lg-0 px-lg-3 px-2">
              <Switch>
                {getRoutes(routes)}
                <Redirect from="*" to="/auth/login" />
              </Switch>
            </Col>
            <Col lg={7} className="bg-dark pb-4 pb-lg-0 px-lg-3 px-2">
              <div>
                <h2 className="text-white-1 auth-desc-title">
                  HOW FANS HELP PLAYERS IS A WIN-WIN
                </h2>
                <p className="text-white-1 auth-desc-subtitle">
                  We all love our favorite school teams - but some <br />{" "}
                  players struggle just to pay their bills. Now we FANS <br />{" "}
                  can help. Here’s how:
                </p>
                <Row>
                  <Col>
                    <p className="text-white-1 auth-desc-points">
                      1- Players all get signed up right here. And Fans, we each
                      find our favorite player by searching.
                      <br />
                      <br />
                      2. Then Student Athletes can assemble digital files called
                      Badges and Mementos right here online.
                      <br />
                      <br />
                      3. Then fans shop right here to see the Badges and
                      Mementos made by our Fav Student Athletes.
                      <br />
                      <br />
                      4. When a Fan buys, they get a Treasure to keep, and the
                      Student Athlete gets up to 88% of the money. A Win-Win.
                    </p>
                  </Col>
                  <Col className="text-right d-none d-sm-block">
                    <img src={PinClipart1} alt="PinClipart1" height="490px" />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Auth;
